import JamMessages from '@/src/components/game/JamMessages/JamMessages';
import React from 'react';

export const JamEventMessagesPage: React.FC = () => {
  return <JamMessages />;
};
